/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kvkkbasvuru_S2_HeadingInputs */

const tr_kvkkbasvuru_s2_heading = /** @type {(inputs: Kvkkbasvuru_S2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Başvuru Kanalları`)
};

const en_kvkkbasvuru_s2_heading = /** @type {(inputs: Kvkkbasvuru_S2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Application Channels`)
};

const de_kvkkbasvuru_s2_heading = /** @type {(inputs: Kvkkbasvuru_S2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Antragswege`)
};

const ru_kvkkbasvuru_s2_heading = /** @type {(inputs: Kvkkbasvuru_S2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Каналы подачи обращения`)
};

/**
* | output |
* | --- |
* | "2. Application Channels" |
*
* @param {Kvkkbasvuru_S2_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kvkkbasvuru_s2_heading = /** @type {((inputs?: Kvkkbasvuru_S2_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kvkkbasvuru_S2_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kvkkbasvuru_s2_heading(inputs)
	if (locale === "de") return de_kvkkbasvuru_s2_heading(inputs)
	if (locale === "ru") return ru_kvkkbasvuru_s2_heading(inputs)
	return tr_kvkkbasvuru_s2_heading(inputs)
});